import { EventCategory } from '../types/calendar-event';
import {
  Users,
  Calendar,
  GraduationCap,
  Heart,
  AlertCircle,
  Crown,
  Gift,
  Sun,
  Trophy,
  Info,
  type LucideIcon,
} from 'lucide-react';

// 統一的 Event 視覺樣式 - 紅色背景強調外部承諾的重要性
export const eventUnifiedColors = 'bg-red-100 text-red-900';

export const eventCategoryConfig: Record<
  EventCategory,
  { label: string; icon: LucideIcon }
> = {
  meeting: {
    label: 'Meeting',
    icon: Users, // 會議有人參與
  },
  appointment: {
    label: 'Appointment',
    icon: Calendar,
  },
  class: {
    label: 'Class',
    icon: GraduationCap, // 課程/培訓更有教育感
  },
  social: {
    label: 'Social',
    icon: Heart, // 社交活動的親密感
  },
  deadline: {
    label: 'Deadline',
    icon: AlertCircle, // 更有緊迫感
  },
  ceremony: {
    label: 'Ceremony',
    icon: Crown, // 儀式的莊重感
  },
  anniversary: {
    label: 'Anniversary',
    icon: Gift,
  },
  holiday: {
    label: 'Holiday',
    icon: Sun, // 假期的輕鬆感
  },
  competition: {
    label: 'Competition',
    icon: Trophy,
  },
  other: {
    label: 'Other',
    icon: Info, // 通用資訊
  },
};
